module.exports = "<footer class=\"app-footer\">\n  <span class=\"float-right\">Powered by <a href=\"http://www.ahavahtech.net\">Ahavah Technologies</a></span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-footer/app-footer.component.html
// module id = ./src/app/components/app-footer/app-footer.component.html
// module chunks = main